export enum IRoleType {
  Assistant = 'Assistant',
  Accounting = 'Accounting',
  Producer = 'Producer',
  SystemAdmin = 'SystemAdmin',
  ImportUser = 'Import',
  DynamicFields = 'DynamicFieldsUser',
  Marketing = 'Marketing',
}
